// Static data — IDs match the UUIDs in the MongoDB database on Render
// Committee order follows experience level: beginner → intermediate → advanced
// so registration form submissions can find the correct committee on the backend.

export const STATIC_COMMITTEES = [
    // ── 1. BEGINNER ─────────────────────────────────────────────────────────────
    {
        id: "c0479710-ce48-484d-b60c-1093f46c566d",
        name: "United Nations General Assembly",
        name_ru: null,
        description:
            "The United Nations General Assembly is the principal deliberative, policymaking, and representative organ of the United Nations, comprising all 193 Member States on an equal footing. It provides a unique forum for multilateral discussion of the full spectrum of international issues covered by the UN Charter, including peace and security, economic development, and human rights. The General Assembly has the authority to make recommendations on matters of international importance, and its resolutions reflect the breadth of global consensus. It serves as a standard-setting body on various issues ranging from disarmament and decolonization to sustainable development and international law.",
        agenda: [
            "Addressing the Challenges of Foreign Political Interference via Technology and Media",
        ],
        background_image: "./committees/ga.jpg",
        chairs: [
            {
                id: "4d7b4b61-8e68-456f-b993-f67b0824c114",
                name: "Darina Galchevskaya",
                role: "Main Chair",
                experience:
                    "A student at Central Asian University, Darina combines extensive MUN leadership experience with strong analytical discipline. She is known for running structured, policy-focused debates where arguments are expected to be precise, legally grounded, and strategically coherent.",
                photo_url: "./secretariat/darina_galchevskaya.jpg",
                image_position: "center 55%",
            },
            {
                id: "6f6bdbdd-c0de-49ab-b19a-660d04d1ffd1",
                name: "Aziza Tillakhujaeva",
                role: "Co-Chair",
                experience:
                    "A graduating student of Target International School, Aziza brings award-winning debate experience and a sharp understanding of digital governance issues. She prioritizes intellectual clarity and solution-oriented diplomacy.",
                photo_url: "./secretariat/aziza_tillakhujaeva.jpg",
                image_position: "center 50%",
            },
            {
                id: "ga-cochair-masrur",
                name: "Masrur Anorov",
                role: "Co-Chair",
                experience:
                    "Masrur is an experienced MUNer with a deep understanding of international diplomacy and parliamentary procedures. Known for his commitment to fostering inclusive debate, he empowers delegates to navigate complex geopolitical agendas and develop sustainable global solutions.",
                photo_url: "./secretariat/masrur_anorov.jpg",
                image_position: "center 30%",
            },
        ],
        registration_open: true,
        order: 1,
    },
    {
        id: "3e6b61f0-9e26-44df-81f4-cd975ffd786d",
        name: "United Nations Commission on Narcotic Drugs",
        name_ru: null,
        description:
            "The United Nations Commission on Narcotic Drugs (CND) is the central policymaking body within the United Nations system on drug-related matters. Established in 1946, the Commission is mandated by the General Assembly to assist the Economic and Social Council in supervising the application of international drug control treaties. The CND reviews and analyzes the global drug situation, develops strategies and practical recommendations for member states, and takes decisions on the scheduling of substances under international control. Through its annual sessions and intersessional activities, it provides a platform for member states, civil society, and international organizations to advance evidence-based approaches to drug control, prevention, treatment, and rehabilitation.",
        agenda: [
            "Prevention of Drug Use Among Youth",
        ],
        background_image: "./committees/unodc.JPG",
        chairs: [
            {
                id: "5b33db74-8a57-4d55-9667-254724d41b00",
                name: "Hilola Sotimkulova",
                role: "Main Chair",
                experience:
                    "A freshman in International Relations at Webster University, Hilola approaches regional security topics with academic depth and practical debate experience across multiple MUN leadership roles.",
                photo_url: "./secretariat/hilola_sotimkulova.jpg",
                image_position: "center 50%",
            },
            {
                id: "50cc16d9-c41e-4552-8ab8-c807e4bb1c32",
                name: "Muazzam Muminova",
                role: "Co-Chair",
                experience:
                    "Student at ALWIUT and active MUN participant since 2023, Muazzam is recognized for structured moderation and consistent high-level engagement across committees.",
                photo_url: "./secretariat/muazzam_muminova.jpg",
                image_position: "center 50%",
            },
            {
                id: "5f2ad2d3-4897-4bda-b7d9-c58a2213c167",
                name: "Khadija Bakhromova",
                role: "Co-Chair",
                experience:
                    "Known for her work as a writer and organizer, Khadija brings strong rhetorical skills and confident public speaking to committee leadership.",
                photo_url: "./secretariat/khadija_bakhromova.jpg",
                image_position: "center 50%",
            },
        ],
        registration_open: true,
        order: 2,
    },
    // ── 2. INTERMEDIATE ─────────────────────────────────────────────────────────
    {
        id: "3af8bf29-718d-4b34-9850-a9a2919d4492",
        name: "Commission on Crime Prevention and Criminal Justice",
        name_ru: null,
        description:
            "The Commission on Crime Prevention and Criminal Justice (CCPCJ) serves as the principal policymaking body of the United Nations on criminal justice matters, guiding the work of UNODC in implementing international standards globally. Established in 1992, it coordinates international efforts on crime prevention, criminal justice reform, and combating transnational organized crime. The Commission develops international standards, norms, and recommendations in the field of crime prevention, and conducts research into emerging criminal justice trends. It works in close partnership with member states and UNODC to address the evolving challenges posed by organized crime, environmental crimes, and cybercrime.",
        agenda: [
            "Implementation of the United Nations Convention against Cybercrime: Strengthening Criminal Justice Responses to ICT-facilitated Violence Against Women and Girls",
        ],
        background_image: "./committees/ccpcj.jpg",
        chairs: [
            {
                id: "26205455-a26a-4a7a-a02b-530b42368375",
                name: "Dilrabokhon Olimkhonova",
                role: "Main Chair",
                experience:
                    "Dilrabo is a graduate of Westminster International School in Tashkent and currently studies at BMU. With over 30 MUN conferences behind her, she has served as Secretary-General, Vice Secretary-General, Chair, and delegate, earning awards including Best Delegate and Best Chair. Alongside MUN, she also runs her own online business.",
                photo_url: "./secretariat/dilrabokhon_olimkhonova.png",
                image_position: "center 50%",
            },
            {
                id: "41cc5c59-b441-47c3-b00a-a1b04b8859e0",
                name: "Maftuna Alisherova",
                role: "Co-Chair",
                experience:
                    "A graduating student of Vosiq International School, Maftuna combines leadership experience with a rigorous approach to debate and global affairs. With experience in leadership and organizational roles, she is less concerned with sounding convincing and more focused on whether an argument truly makes sense.",
                photo_url: "./secretariat/maftuna_alisherova.jpg",
                image_position: "center 50%",
            },
            {
                id: "1cf9e072-61d7-4e64-a1f0-0a1c13bad43d",
                name: "Roman Kim",
                role: "Co-Chair",
                experience:
                    "Student at The British School of Tashkent and Secretary-General of BSTMUN '25, Roman combines international-level recognition with confident committee management and strong procedural control.",
                photo_url: "./secretariat/roman_kim.jpg",
                image_position: "center 50%",
            },
        ],
        registration_open: true,
        order: 3,
    },
    {
        id: "75ead8f2-901c-45f4-a212-39347eaed0e0",
        name: "International Organization for Migration",
        name_ru: null,
        description:
            "The International Organization for Migration (IOM) is the leading intergovernmental organization dedicated to promoting humane and orderly migration for the benefit of all — migrants, societies, and governments alike. Founded in 1951, IOM works closely with governmental, intergovernmental, and non-governmental partners to address migration challenges and advance understanding of migration issues. It fulfills a critical role in addressing the humanitarian needs of migrants, refugees, and internally displaced persons, through coordination of emergency responses and long-term programming. Operating in more than 170 countries, IOM is committed to upholding the dignity and rights of migrants while supporting states in the effective management of migration.",
        agenda: [
            "Addressing the Humanitarian Consequences of Mass Deportation Operations on Migrant Communities",
        ],
        background_image: "./committees/migration.JPG",
        banner_position: "center 80%",
        chairs: [
            {
                id: "5fe180b1-2471-4a07-a218-2affea3480f1",
                name: "Ezoza Bobomurodova",
                role: "Main Chair",
                experience:
                    "A sophomore majoring in International Relations at Webster University in Tashkent, Ezoza has chaired extensively and is known for maintaining analytical depth and procedural professionalism in humanitarian debates.",
                photo_url: "./secretariat/ezoza_bobomurodova.jpg",
                image_position: "center 50%",
            },
            {
                id: "dd66a9e7-eb17-42f5-a053-2cce66798a3d",
                name: "Khonzodabegim Burkhonova",
                role: "Co-Chair",
                experience:
                    "A sophomore at TSUL, Khonzodabegim combines legal academic training with consistent MUN leadership experience, emphasizing structured and policy-based discussions.",
                photo_url: "./secretariat/khonzodabegim_burkhonova.jpg",
                image_position: "center 50%",
            },
            {
                id: "90da4699-fded-4fa1-b882-e704f52d20dc",
                name: "Saida Adkhamova",
                role: "Co-Chair",
                experience:
                    "A Year 11 student at The British School of Tashkent and two-time \"Best Chair\" recipient, Saida is recognized for balanced moderation and high debate standards.",
                photo_url: "./secretariat/saida_adkhamova.jpg",
                image_position: "center 50%",
            },
        ],
        registration_open: true,
        order: 4,
    },
    // ── 3. ADVANCED ─────────────────────────────────────────────────────────────
    {
        id: "f8dda8b1-dd4c-4dee-a735-bec48d36e2d1",
        name: "United Nations Security Council",
        name_ru: null,
        description:
            "The United Nations Security Council holds primary responsibility for the maintenance of international peace and security under the UN Charter, making it the most powerful decision-making body within the United Nations system. It consists of 15 members: five permanent members with veto power — China, France, Russia, the United Kingdom, and the United States — and ten non-permanent members elected by the General Assembly for two-year terms. The Security Council has the authority to impose legally binding resolutions, establish peacekeeping missions, authorize the use of force, and implement international sanctions against states or non-state actors. It convenes whenever international peace or security is perceived to be threatened, demanding delegates to engage with high-stakes geopolitical scenarios under strict time pressure.",
        agenda: [
            "Mitigating Armed Conflicts and Terrorist Expansion in the Sahel Region",
        ],
        background_image: "./committees/secrity.JPG",
        chairs: [
            {
                id: "322020ca-8861-4c71-b0af-0800648dffef",
                name: "Abdumajid Toshmatov",
                role: "Main Chair",
                experience:
                    "A sophomore at TSUE and active professional at Payme, Abdumajid brings extensive conference experience and a decisive leadership style suited for crisis-driven Security Council simulations.",
                photo_url: "./secretariat/abdumajid_toshmatov.jpg",
                image_position: "center 50%",
            },
            {
                id: "sc-cochair-dilrabo",
                name: "Dilnoza Yuldasheva",
                role: "Co-Chair",
                experience:
                    "Webster University student. More than 20 MUN conferences, several awards, various roles. Through her experieces she has made exceptional contribution to the MUNs in Uzbekistan.",
                photo_url: "./secretariat/dilnoza_yuldasheva.png",
                image_position: "center 50%",
            },
            {
                id: "79323f6b-c483-4dad-b999-3fdc9b2d8f83",
                name: "Mark Tokarev",
                role: "Co-Chair",
                experience:
                    "A student at Interhouse Lyceum, Mark combines competitive delegate experience with confident chairing, ensuring disciplined and strategic debate.",
                photo_url: "./secretariat/mark_tokarev.jpg",
                image_position: "center 10%",
                image_scale: 1.1,
            },
        ],
        registration_open: true,
        order: 5,
    },
    {
        id: "f718c2fa-69fc-4839-899b-3627c8f143f4",
        name: "Congress Of Vienna",
        name_ru: null,
        description:
            "The Congress Of Vienna was a landmark diplomatic conference held in 1814–1815 to reshape the political landscape of Europe following the Napoleonic Wars, bringing together representatives of all major European powers. Delegates were tasked with establishing a new political order, redrawing national borders, and creating a framework for maintaining peace and stability across the continent for generations to come. The Conference established the Concert of Europe, an innovative system of multilateral diplomacy and collective security that governed European affairs for nearly a century. This committee simulates the historical negotiations and strategic decisions of the Conference, challenging delegates to analyze and engage with the complex diplomatic realities of the early nineteenth century.",
        agenda: ["Historical Simulation (Restoring Order in Europe)"],
        background_image: "./committees/congressofviena.JPG",
        chairs: [
            {
                id: "f09170d8-599f-4129-b453-285441dc3b2d",
                name: "Saidakhmadkhon Saydaminov",
                role: "Conference Arbiter",
                experience:
                    "Active in MUN since 2020 with international conference recognition, Saidakhmadkhon specializes in historical simulations and structured diplomatic negotiation.",
                photo_url: "./secretariat/saidakhmadkhon_saydaminov.jpg",
                image_position: "center 50%",
            },
            {
                id: "b3dbe5cb-52ae-407a-b7b1-e112dc771ee4",
                name: "Neve Marie Krige",
                role: "Chairperson",
                experience:
                    "Participating in MUN since 2023, Neve has earned international-level recognition and is committed to maintaining historically grounded and strategically dynamic debate.",
                photo_url: "./secretariat/neve_marie_krige.jpg",
                image_position: "center 50%",
            },
        ],
        registration_open: true,
        order: 6,
    },
    {
        id: "ff5ad85e-ef00-43e1-acee-f7869eda4ffe",
        name: "Комитет Государственной Думы России",
        name_ru: "Комитет Государственной Думы России",
        description:
            "Комитет Государственной Думы Российской Федерации — это симуляция заседания нижней палаты российского парламента, принимающей федеральные законы и определяющей внутреннюю политику страны. Государственная Дума является ключевым законодательным органом власти, в котором представлены различные политические фракции с разными позициями по острым вопросам государственного управления. В рамках данного комитета делегаты рассматривают значимые исторические события, дискутируют о законодательных решениях и анализируют политические процессы России через призму парламентских дебатов. Симуляция проводится полностью на русском языке, что позволяет делегатам развить дипломатические, аналитические и ораторские навыки в профессиональном академическом формате.",
        agenda: [
            "\u00ab\u0427\u0451\u0440\u043d\u044b\u0439 \u043e\u043a\u0442\u044f\u0431\u0440\u044c\u00bb: \u041f\u043e\u043b\u0438\u0442\u0438\u0447\u0435\u0441\u043a\u0438\u0439 \u0438 \u043a\u043e\u043d\u0441\u0442\u0438\u0442\u0443\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043a\u0440\u0438\u0437\u0438\u0441 1993 \u0433\u043e\u0434\u0430 \u0432 \u0420\u043e\u0441\u0441\u0438\u0438.",
        ],
        background_image: "./committees/gosduma.jpg",
        chairs: [
            {
                id: "c1e1fb4f-3b5e-4631-b27d-19f8d94d6053",
                name: "\u0410\u0441\u0430\u043b\u044c \u0428\u0443\u043a\u0443\u0440\u043e\u0432\u0430",
                role: "\u041f\u0440\u0435\u0434\u0441\u0435\u0434\u0430\u0442\u0435\u043b\u044c",
                experience:
                    "\u041f\u0435\u0440\u0432\u043e\u043a\u0443\u0440\u0441\u043d\u0438\u0446\u0430 \u0410\u043a\u0430\u0434\u0435\u043c\u0438\u0447\u0435\u0441\u043a\u043e\u0433\u043e \u043b\u0438\u0446\u0435\u044f \u0418\u043d\u0442\u0435\u0440\u0445\u0430\u0443\u0441 \u0441 \u0431\u043e\u043b\u0435\u0435 20 \u043a\u043e\u043d\u0444\u0435\u0440\u0435\u043d\u0446\u0438\u044f\u043c\u0438 \u041c\u041e\u041e\u041d. \u0410\u0441\u0430\u043b\u044c \u0441\u043e\u0447\u0435\u0442\u0430\u0435\u0442 \u043e\u043f\u044b\u0442 \u043f\u0440\u0435\u0434\u0441\u0435\u0434\u0430\u0442\u0435\u043b\u044c\u0441\u0442\u0432\u0430 \u0441 \u0432\u043d\u0438\u043c\u0430\u043d\u0438\u0435\u043c \u043a \u044e\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043a\u043e\u0439 \u0430\u0440\u0433\u0443\u043c\u0435\u043d\u0442\u0430\u0446\u0438\u0438 \u0438 \u043f\u043e\u043b\u0438\u0442\u0438\u0447\u0435\u0441\u043a\u043e\u043c\u0443 \u043a\u043e\u043d\u0442\u0435\u043a\u0441\u0442\u0443.",
                photo_url: "./secretariat/asal_shukurova.jpg",
                image_position: "center 50%",
            },
            {
                id: "e9fc0ef2-17a8-47c4-a2fd-67dcb6526000",
                name: "\u041c\u0430\u0440\u0438\u044f\u043c \u041c\u0435\u043b\u0430\u043d-\u041c\u0435\u043b\u0438\u0431\u0430\u0435\u0432\u0430",
                role: "\u041f\u0440\u0435\u0434\u0441\u0435\u0434\u0430\u0442\u0435\u043b\u044c",
                experience:
                    "\u0421\u0442\u0443\u0434\u0435\u043d\u0442\u043a\u0430 \u0412\u0435\u0431\u0441\u0442\u0435\u0440\u0441\u043a\u043e\u0433\u043e \u0443\u043d\u0438\u0432\u0435\u0440\u0441\u0438\u0442\u0435\u0442\u0430 \u0432 \u0422\u0430\u0448\u043a\u0435\u043d\u0442\u0435, \u0443\u0447\u0430\u0441\u0442\u043d\u0438\u0446\u0430 \u0431\u043e\u043b\u0435\u0435 17 \u043a\u043e\u043d\u0444\u0435\u0440\u0435\u043d\u0446\u0438\u0439 \u041c\u041e\u041e\u041d \u0438 \u0428\u041e\u0421. \u041c\u0430\u0440\u0438\u044f\u043c \u0438\u0437\u0432\u0435\u0441\u0442\u043d\u0430 \u043a\u0430\u043a \u0443\u0432\u0435\u0440\u0435\u043d\u043d\u044b\u0439 \u0438 \u0434\u0438\u0441\u0446\u0438\u043f\u043b\u0438\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u043d\u044b\u0439 \u043c\u043e\u0434\u0435\u0440\u0430\u0442\u043e\u0440 \u043f\u043e\u043b\u0438\u0442\u0438\u0447\u0435\u0441\u043a\u0438\u0445 \u0434\u0438\u0441\u043a\u0443\u0441\u0441\u0438\u0439.",
                photo_url: "./secretariat/mariyam_melibaeva.jpg",
                image_position: "center 50%",
            },
        ],
        registration_open: true,
        order: 7,
    },
    {
        id: "b75e9bfa-fc84-478c-9a2f-f9778fe0545e",
        name: "Press Corps",
        name_ru: null,
        description:
            "The Press Corps is a unique committee that operates differently from all other committees at this conference, offering delegates a distinctive perspective on conference diplomacy. Rather than debating resolutions, delegates in the Press Corps act as journalists, reporters, editors, and media professionals tasked with covering the proceedings of all other committees in real time. Members of the Press Corps produce written articles, multimedia content, and live reporting that captures the debates, key speeches, and outcomes emerging from across the conference. This committee offers an exceptional experience for delegates interested in journalism, communication, and the critical role of media in shaping public discourse on international affairs. Note: Press Corps supports Double Delegation, allowing participants to register and work in pairs.",
        agenda: ["No Fixed Agenda"],
        background_image: "/committees/press.JPG",
        is_double_delegation: true,
        chairs: [
            {
                id: "a958cd74-c60e-4a97-8983-43749bb98374",
                name: "Nozanin Makhmudova",
                role: "Editor-in-Chief",
                experience:
                    "Senior at Interhouse Lyceum with over 20 conferences of experience, Nozanin oversees analytical reporting and structured media coordination within the Press Corps.",
                photo_url: "./secretariat/nozanin_makhmudova.png",
                image_position: "center 50%",
            },
            {
                id: "21e5e682-2f55-47d2-bbea-ce9ebf317eee",
                name: "Lola Yuldasheva",
                role: "Editor-in-Chief",
                experience:
                    "With a background in design and media production, Lola ensures professional visual storytelling and organized media coverage throughout the conference.",
                photo_url: "./secretariat/lola_yuldasheva.png",
                image_position: "center 30%",
            },
        ],
        registration_open: true,
        order: 8,
    },
];

export const STATIC_SETTINGS = {
    registration_open: true,
    conference_date: "28\u201329 March 2026",
    conference_location: "International House Lyceum, Tashkent",
    about_description:
        "IHL Model United Nations is the premier MUN conference in Uzbekistan, bringing together young diplomats from across the region to debate critical global issues, develop diplomatic skills, and build lasting connections.",
    instagram_url: "https://www.instagram.com/ihl_mun",
};

export const STATIC_SECRETARIAT = [
    {
        id: "sec-dg",
        name: "Khojiakbar Turabekov",
        role: "Director-General",
        photo_url: "./secretariat/khojiakbar_turabekov.jpg",
        experience: "Ensuring effective operational and administrative management.",
        tier: 1
    },
    {
        id: "sec-sg",
        name: "A’zamjonov Abdurakhmon",
        role: "Secretary-General",
        photo_url: "./secretariat/abdurakhmon_azamjonov.jpg",
        imagePosition: "center 20%",
        experience: "Leading the conference with overarching authority.",
        tier: 1
    },
    {
        id: "sec-vsg",
        name: "Mirzakarimov Amirkhon",
        role: "Vice-Secretary General",
        photo_url: "./secretariat/amirkhon_mirzakarimov.jpg",
        experience: "Assisting the Secretary-General in key conference matters.",
        tier: 1
    },
    {
        id: "sec-event",
        name: "Jong Sabina",
        role: "Head of Event",
        photo_url: "./secretariat/sabina_jong.jpg",
        experience: "Organizing logistics, opening/closing ceremonies, and social events.",
        tier: 2
    },
    {
        id: "sec-volunteers",
        name: "Seyt-Akaeva Elina",
        role: "Head of Volunteers",
        photo_url: "./secretariat/elina_seyt_akaeva.jpg",
        experience: "Coordinating and training the volunteer staff for the conference.",
        tier: 2
    },
    {
        id: "sec-media",
        name: "Muradkasimova Kamila",
        role: "Head of Media",
        photo_url: "./secretariat/kamila_muradkasimova.jpg",
        experience: "Managing public relations, content creation, and media strategies.",
        tier: 2
    },
    {
        id: "sec-delegate",
        name: "Kayumov Shakhboz",
        role: "Head of Delegate Affairs",
        photo_url: "./secretariat/shakhboz_kayumov.png",
        experience: "Handling all delegate communications and registration affairs.",
        tier: 2
    },
    {
        id: "sec-site",
        name: "Muxammadamin Isamiddinov",
        role: "Site Developer",
        photo_url: "./secretariat/muxammadamin_isamiddinov.png",
        experience: "Managing the conference website and digital infrastructure.",
        tier: 2
    },
    {
        id: "sec-usg",
        name: "Bekmuratov Tair",
        role: "Head of USG",
        photo_url: "./secretariat/bekmuratov_tair.jpg",
        experience: "Coordinating Under-Secretary-General affairs and conference operations.",
        tier: 2
    }
];
